import { createFileRoute } from '@tanstack/react-router'
import { NotFoundScreen } from '@/components/not-found-screen'

/**
 * The catch-all inside the signed-in layout. TanStack hands an address that matches
 * no route to the ROOT's not-found component, outside the app shell; this splat
 * route claims every unknown signed-in address first, so the user keeps the rail
 * and the top bar and gets a way back.
 */
export const Route = createFileRoute('/_authenticated/$')({
  component: () => <NotFoundScreen variant="app" />,
})
